import React from 'react';
import { CustomerFooterWrapper } from './style';
import { customerService, footerInfo } from '../../messages/contactInfo';
import { useNavigate } from 'react-router-dom';
import ROUTE_PATH from '../../routes/config';

const CustomerFooter = ({ hasKaKao = false, hasInfo = false }) => {
  const navigate = useNavigate();
  const { serviceCenter } = ROUTE_PATH;
  const { phoneContact, businessHour, lunchHour } = customerService;

  const onClickQnA = () => {
    navigate(serviceCenter.qnaListPage + '?tab=QnA');
  };

  return (
    <CustomerFooterWrapper className="customerFooterWrapper">
      <p className="title">상담원 도움이 필요하신가요?</p>
      <div className="btnGroup">
        <button
          type="button"
          onClick={() =>
            (window.location.href = `tel:${footerInfo.phoneContact}`)
          }
        >
          전화 상담
        </button>
        {hasKaKao ? (
          <button
            type="button"
            className="btnKaKao"
            onClick={() =>
              window.open(
                'https://pf.kakao.com/_xdxixigxj/chat',
                '_blank',
                'noopener,noreferrer'
              )
            }
          >
            <img src="/images/cacaotalk.png" alt="카카오톡 상담" /> 카카오톡
            상담
          </button>
        ) : (
          <button type="button" onClick={onClickQnA}>
            1:1 문의하기
          </button>
        )}
      </div>
      {hasInfo && (
        <ul>
          <li>고객센터 : {phoneContact}</li>
          <li>운영시간 : {businessHour}</li>
          <li>점심시간 : {lunchHour}</li>
          <li>점심 시간, 주말 및 공휴일은 상담이 어렵습니다.</li>
          <li>
            <i onClick={onClickQnA}>1:1문의</i> 남겨주세요.
          </li>
        </ul>
      )}
    </CustomerFooterWrapper>
  );
};

export default CustomerFooter;
